<template>
  <div
    class="standard-input-container standard-select-container"
    :class="{
      'focus': focus || !!value,
      'disabled': disabled,
    }"
  >
    <label
      v-if="labelText"
      class="standard-input-label"
    >
      {{ label }}
    </label>
    <div class="standard-input-wrapper">
      <svg svg-inline="" class="select-arrow" :class="{ 'open': focus }" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M9.1 16.8L19.4 27c.2.2.5.3.6.3.3 0 .5-.1.6-.3l10.2-10.2c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0L20 20.3l-7.2-7.2c-.4-.4-1-.4-1.4 0l-2.3 2.3c-.3.4-.3 1 0 1.4z" fill="#111"/></svg>
      <input
        @click="toggle()"
        @focus="onFocus()"
        @blur="onBlur()"
        type="text"
        class="standard-input"
        :disabled="disabled"
        :value="input"
        readonly
      >
      <ul
        class="select-options"
        :class="{
          'open': open,
        }"
      >
        <template
          v-if="open">
          <li
            class="select-option"
            v-for="(option, index) in options"
            :key="index"
            @click="selectOption(option)"
          >
            {{ optionName.length ? getStringValue(option, optionName) : option }}
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      focus: false,
      open: false,
      input: '',
    };
  },
  props: {
    labelText: {
      default: () => '',
      type: String,
    },
    arrowColor: {
      default: () => 'black',
      type: String,
    },
    options: {
      default: () => [],
      type: [Array, Set],
    },
    optionName: {
      default: () => '',
      type: [String, Array],
    },
    value: {
      default: () => '',
      type: String,
    },
    showKw: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    label() {
      if (this.required) {
        return `${this.labelText} *`;
      }
      return this.labelText;
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    selectOption(option) {
      this.input = this.getStringValue(option, this.optionName) || option;
    },
    getStringValue(option, optionName) {
      if (Array.isArray(optionName)) {
        // optionName.map(name => option[name]).join(' ');
        if (this.showKw) {
          return optionName.map((name) => {
            if (name === 'quattro') {
              if (option[name]) {
                return 'KW 4x4';
              }
              return 'KW';
            }
            return option[name];
          }).join(' ');
        }
        return optionName.map((name) => {
          if (name === 'quattro') {
            if (option[name]) {
              return '4x4';
            }
            return '';
          }
          return option[name];
        }).join(' ');
      }
      return null;
    },
    onBlur() {
      this.focus = false;
      setTimeout(() => {
        this.open = false;
      }, 250);
    },
    onFocus() {
      this.focus = true;
    },
  },
  watch: {
    input() {
      this.$emit('selected', this.input);
    },
    value() {
      if (this.showKw) {
        if (this.value.includes('4x4')) {
          this.input = this.value.replace('4x4', 'KW 4x4');
        } else {
          this.input = `${this.value} KW`;
        }
      } else {
        this.input = this.value;
      }
    },
  },
  mounted() {
    this.$emit('select_mounted');
    this.input = this.value;
  },
};
</script>
